// @flow

import TypeaheadFioInput from './typeahead-fio-input';
import { default as TypeaheadFioInputTemplate } from './templates/index.html';

export const COMPONENTS_TYPEAHEAD_FIO_INPUT_NAME = 'typeahead-fio-input';

export const COMPONENTS_TYPEAHEAD_FIO_INPUT_ENTITIES = [
	{
		name: COMPONENTS_TYPEAHEAD_FIO_INPUT_NAME,
		entity: TypeaheadFioInput,
		template: TypeaheadFioInputTemplate,
	},
];
